import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { LangService } from 'src/app/core/services/lang.service';
import { CommonService } from '../../../services/common.service';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
import { GridService } from 'src/app/shared/services/grid.service';

@Component({
  selector: 'app-accounts-assert-list',
  templateUrl: './../../../templates/forms/modals/accounts-list.component.html',
})
export class AccountsAssertListComponent implements OnInit {
  @Input()
  config: any;

  @Input()
  accountsListModalExtarnalValue;

  @Input()
  modalShow: boolean = true;
  
  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "AccountsAssertListGrid"

  dataObj:any;

  chartOfAccountList: any[] = [];
  searchFields: any[] = ['ACC_NAME', 'ACC_NO'];
  public searchString;

  constructor(public langService: LangService, private dataService: CommonService, public gridService: GridService) { 
    this.colObj = [
      { headerName: langService.langData.accountName, field: 'ACC_NAME', sortable: true, resizable: true, hide: false },
      { headerName: langService.langData.accCode, field: 'ACC_CODE', sortable: true, resizable: true, hide: false },
      { headerName: langService.langData.accNo, field: 'ACC_NO', sortable: true, resizable: true, hide: false }
    ];
  }

  ngOnInit() {
     
      this.dataService.getChartOfAccounts(fixedValues.queryOptions.CoaForParent)
      .subscribe(arg => { this.chartOfAccountList = arg.body });
  }
  onGridReady(grid) {
    this.grid = grid;
    this.gridService.sizeColumnsToFit(grid, this.gridId); 

    if (this.accountsListModalExtarnalValue) {
      this.dataService.getChartOfAccounts(this.accountsListModalExtarnalValue)
        .subscribe(arg => {
          this.chartOfAccountList = arg.body
        });
    }
    else {
      this.dataService.getChartOfAccounts(fixedValues.queryOptions.CoaForCSOB)
        .subscribe(arg => { this.chartOfAccountList = arg.body });
    }
  }
  itemClick(_item) {
    this.modalShow = false; 
    this.dataObj=_item;
    this.submit.next();
  }
}
